import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary hierarchies-target-dialog",
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.hierarchyManagement.hierarchiesTarget')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.ok')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        class: "p-datatable-sm kn-table",
        value: _ctx.targets,
        selection: _ctx.selectedTargets,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTargets = $event)),
        dataKey: "MT_ID"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            style: _ctx.hierarchyManagementHierarchiesTreeDescriptor.selectColumnStyle
          }, null, 8, ["style"]),
          _createVNode(_component_Column, {
            field: "label",
            header: _ctx.$t('common.label'),
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("div", null, [
                _createVNode("span", null, [
                  _createVNode("b", null, _toDisplayString(_ctx.getLabel(slotProps.data)), 1)
                ]),
                _hoisted_1,
                _createVNode("span", null, _toDisplayString(slotProps.data.PATH_NM_T), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "selection"])
    ]),
    _: 1
  }, 8, ["visible"]))
}